export default "<mat-card class='postit'>\n    <p>\n      {{text}}\n    </p>\n</mat-card>";